import { useRef} from 'react'

import get from 'lodash/get'

import classNames from 'classnames'

import styles from './block_wrapper.module.sass'

import config from '../../config'

import { v4 as uuidv4 } from 'uuid'

function BlockWrapper(props) {
	const uuidRef = useRef('component_' + uuidv4())

	let columnClass = props.editor ? '' : styles[`col-${props.grid_details?.col}`]

	const layoutSettings = get(props, 'fields.layout_settings', props.layout_settings) || null 
	
	let fullBleed = null
	let layoutStyles = ``
	let mobileLayoutStyles = ``
	const wrapperStyle = {}

	if(layoutSettings){
		const backgroundColor = layoutSettings.background_color

		if (!props.editor && props.fullbleed != false && layoutSettings.full_bleed_background_color && props.name != 'sidebar' && props.tabbed_content != true) {
			fullBleed = <div className={styles.full_bleed} style={{backgroundColor: layoutSettings.full_bleed_background_color}}></div>
		}

		if (backgroundColor) {
			wrapperStyle.backgroundColor = backgroundColor
		}

		if (props.editor) {
			delete layoutSettings.margin
			delete layoutSettings.margin_mobile
		}

		mobileLayoutStyles += layoutSettings.margin_mobile ? `margin: ${layoutSettings.margin_mobile};` : ''
		mobileLayoutStyles += layoutSettings.padding_mobile ? `padding: ${layoutSettings.padding_mobile};` : ''
		mobileLayoutStyles += layoutSettings.min_width_mobile ? `min-width: ${layoutSettings.min_width_mobile};` : ''
		mobileLayoutStyles += layoutSettings.max_width_mobile ? `max-width: ${layoutSettings.max_width_mobile};` : ''
		mobileLayoutStyles += layoutSettings.order_mobile ? `order: ${layoutSettings.order_mobile};` : ''

		layoutStyles += layoutSettings.margin ? `margin: ${layoutSettings.margin};` : ''
		layoutStyles += layoutSettings.padding ? `padding: ${layoutSettings.padding};` : ''
		layoutStyles += layoutSettings.min_width ? `min-width: ${layoutSettings.min_width};` : ''
		layoutStyles += layoutSettings.max_width ? `max-width: ${layoutSettings.max_width};` : ''
		layoutStyles += layoutSettings.border?.border_width ? `border-width: ${layoutSettings.border.border_width};` : ''
		layoutStyles += layoutSettings.border?.border_color ? `border-color: ${layoutSettings.border.border_color};` : ''
		layoutStyles += layoutSettings.border?.border_style ? `border-style: ${layoutSettings.border.border_style};` : ''

		layoutStyles += layoutSettings.z_index ? `z-index: ${layoutSettings.z_index};` : ''

		layoutStyles = layoutStyles ? `#${props.id || uuidRef.current} {${layoutStyles}}` : ''
		mobileLayoutStyles = mobileLayoutStyles ? `@media (max-width: ${config.mobileWidth}px) {#${props.id || uuidRef.current} {${mobileLayoutStyles}}}` : ''
	}

	if(props.style){
		wrapperStyle.marginTop = props.style?.marginTop
	}

	return <div className={classNames(styles.block_wrapper, columnClass, styles[layoutSettings?.visibility], props.className)} style={wrapperStyle} id={layoutSettings?.id || props.id || uuidRef.current}>
		{fullBleed}
		{(layoutStyles || mobileLayoutStyles) && <style type="text/css">{`${layoutStyles}${mobileLayoutStyles}`}</style>}
		{props.children}
	</div>
}

export default BlockWrapper